import Store from "@/store/index.js";
import axios from "axios";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
const domain = Store.state.domain;

export default {
  BusquedaPorReporte(vm, nrreporte) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", nrreporte);
    return vm.axios
      .post(
        `${vm.domain.domainNameForApi}Busqueda/BusquedaPorReporte`,
        datosReporte
      )
      .then((response) => response.data);
  },
  async BusquedaAvanzadaReporte(vm, formData) {
    let response = await vm.axios.post(
      `${vm.domain.domainNameForApi}Busqueda/BusquedaAvanzadaReporte`,
      formData
    );
    return response;
  },
  async BusquedaAvanzada_Tam(vm, busqueda) {
    let response = await vm.axios.post(
      `${vm.domain.domainNameForApi}Busqueda/BusquedaAvanzada_Tam`,
      busqueda
    );
    return response.data;
  },
  async BusquedaAvanzada(vm, busqueda) {
    let response = await vm.axios.post(
      `${vm.domain.domainNameForApi}Busqueda/BusquedaAvanzada`,
      busqueda
    );
    return response.data;
  },
  ObtenerValidacion(vm, data) {
    data.append("uslogin", MetodosGenerales.ObtenerUserName());
    return vm.axios
      .post(`${vm.domain.domainNameForApi}Busqueda/ObtenerValidacion`, data)
      .then((response) => response.data);
  },
  Desencriptar(vm, url) {
    var datos = new FormData();
    datos.append("url", url);

    return vm.axios
      .post(`${vm.domain.domainNameForApi}Busqueda/DesencriptarUrl`, datos)
      .then((response) => response.data);
  },
  DesencriptarV2(vm, url) {
    var datos = new FormData();
    datos.append("url", url);

    return vm.axios
      .post(`${vm.domain.domainNameForApi}Busqueda/DesencriptarUrlV2`, datos)
      .then((response) => response.data);
  },
  ObtenerHistorial(data) {
    return axios
      .post(`${domain.domainNameForApi}Busqueda/ObtenerHistorial`, data)
      .then((response) => response.data);
  },
  GuardarHistorial(data) {
    return axios
      .post(`${domain.domainNameForApi}Busqueda/GuardarHistorial`, data)
      .then((response) => response.data);
  },
  ObtenerUrlHistorial(data) {
    return axios
      .post(`${domain.domainNameForApi}Busqueda/ObtenerUrlHistorial`, data)
      .then((response) => response.data);
  },
  ObtenerIconoHistorial(data) {
    return axios
      .post(`${domain.domainNameForApi}Busqueda/ObtenerIconoHistorial`, data)
      .then((response) => response.data);
  },
  //ReporteFavoritos(data) {
  //    return axios.post(`${domain.domainNameForApi}Busqueda/ReporteFavoritos`, data).then(response => response.data);
  //},
};
